import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://c15057dd048a4e168c293a580a6d8b29@sentry.prioritymatrix.com/6',
  environment: import.meta.env.DEV ? 'development' : 'production',
  release: import.meta.env.VITE_VERSION,
})

export const getSentry = () => Sentry
